'use client'

import { IconAlertCircleYellow } from '@macarongfactory/web-icons'
import { Result, SolidButton } from '@macarongfactory/web-ui'

import { COMMON_ERROR_DESCRIPTION, COMMON_ERROR_TITLE } from '@/shared/lib'
import { withChunkErrorFallback } from '@/shared/ui'

/** 경고 아이콘 크기(px) — Figma 화면 로드 실패 (56×56) */
const ALERT_ICON_SIZE_PX = 56

/**
 * 화면 로드 실패 (Figma `화면을 불러오지 못할 경우` 9035:21297)
 * "화면을 불러오지 못했어요 / 잠시 후 다시 시도해주세요" + 다시 시도하기.
 */
const Error = ({ reset }: { error: Error; reset: () => void }) => (
  <div className='flex min-h-dvh w-full flex-col items-center justify-center'>
    <Result
      top={
        <Result.Top.Image>
          <IconAlertCircleYellow
            width={ALERT_ICON_SIZE_PX}
            height={ALERT_ICON_SIZE_PX}
          />
        </Result.Top.Image>
      }
      title={<Result.Title text={COMMON_ERROR_TITLE} />}
      description={<Result.Description text={COMMON_ERROR_DESCRIPTION} />}
      button={
        <SolidButton
          text='다시 시도하기'
          variant='neutral-weak'
          size='medium'
          clickable={reset}
        />
      }
    />
  </div>
)

export default withChunkErrorFallback(Error, 'ModoocarHomePage')
